<template>
    <el-dialog
        custom-class="user-org-dialog"
        title="选择审批流模板"
        top="4vh"
        width="75%"
        :visible.sync="isInnerShow"
        append-to-body
      > 
        <el-container class="approval-temp-select">
              <el-aside width="200px">
                    <el-header height="35px">业务分类</el-header>
                    <BusinessTree
                        v-if="isShowTree"
                        :data="treeData"
                        :defaultProps="defaultProps"
                        @nodeClick="handleTreeNode"
                    />
              </el-aside>
              <el-main>
                  <el-container>
                      <el-aside style="width: 55%">
                          <div class="tools-bar">
                              <span><el-tag type="primary">审批流模板列表</el-tag></span>
                              <div class="tools-search" @keyup.enter="handleSearchInDept">
                                  <el-input maxlength="100" v-model.trim="templateName" placeholder="审批流模板名称">
                                      <el-button slot="append" icon="el-icon-search" @click="handleSearchInDept"></el-button>
                                  </el-input>
                              </div>
                          </div>
                          <template v-if="multiple">
                              <el-table  :data="templateListInBusiness" @selection-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                                  <el-table-column type="selection" width="55"></el-table-column>
                                  <el-table-column prop="templateName" label="审批流模板名称"></el-table-column>
                              </el-table>
                          </template>
                            <template v-else>
                                <el-table  :data="templateListInBusiness" highlight-current-row @current-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                                  <el-table-column prop="templateName" label="审批流模板名称"></el-table-column>
                                </el-table>
                            </template>
                          <!-- 分页 -->
                          <el-row type="flex" justify="end">
                              <el-pagination
                                  background
                                  layout="total, prev, pager, next"
                                  :total="totalPageNumInDept"
                                  :current-page="currentPageInDept"
                                  :page-size="pageSizeInDept"
                                  @current-change="queryFormDataInDept"
                                  >
                              </el-pagination>
                          </el-row>
                      </el-aside>
                      <el-aside style="width: 45%">
                          <div class="tools-bar">
                              <span><el-tag type="success">已选择的审批流模板</el-tag></span>
                              <div class="tools-btn-group">
                                  <el-button icon="el-icon-remove" type="danger" @click="handleRemoveselectedApprovalTemplate">移除</el-button>
                              </div>
                          </div>
                          <el-table ref="multipleTable" :data="selectedApprovalTemplateList" @selection-change="handleSelectionRemovedUser" tooltip-effect="dark" style="width: 100%" v-loading="unInDpetloading" stripe>
                              <el-table-column type="selection" width="55"></el-table-column>
                              <el-table-column prop="templateName" label="审批流模板名称"></el-table-column>
                          </el-table>
                      </el-aside>
                  </el-container>            
              </el-main>
          </el-container>
          <span slot="footer" class="dialog-footer">
                <el-button @click="isInnerShow = false">取 消</el-button>
                <el-button type="primary" @click="confirmClick">确 定</el-button>
            </span>
      </el-dialog>
    
</template>

<script>
    import { getBusinessTreeList, getApprovalTemplateList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import { isEmpty } from 'lodash';
    export default {
        mixins: [ mixinsNav ],
        components: {
        },
        data () {
            return {
                isInnerShow: false,
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                isShowTree: false,
                templateName: '', // 流程方案名称查询
                inDpetloading: false,
                templateListInBusiness: [], // 所选业务分类下的流程方案列表
                currentPageInDept: 1, // 当前页码
                pageSizeInDept: 6, // 每页条数
                totalPageNumInDept: 1, // 总页数

                unInDpetloading: false,
                empNameUnInDept: '',
                selectedApprovalTemplateList: [], // 已选择的流程列表数据
                currentPageUnInDept: 1, // 当前页码
                pageSizeUnInDept: 6, // 每页条数
                totalPageNumUnInDept: 1, // 总页数

                selectMap: new Map(),
                currentBusiType: '', // 当前点击的业务分类树
                selectedApprovalTemplateIds: '', // 选中的流程ID
                selectedApprovalTemplateNames: '', // 选中的流程方案名称
                selectedRemovedUserIds: ''// 选中的流程ID
            };
        },
        props: {
            selectedApprovalTemplate: {
                type: Object,
                default: function () {
                    return {
                        selectedApprovalTemplateIds: '',
                        selectedApprovalTemplateNames: ''
                    };
                }
            },
            isShowApprovalTemplatePop: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            },
            maxItemsNum: {
                type: Number,
                default: 3
            }
        },
        created () {
            // this._initPage();
    
        },
        methods: {
            async _initPage () {
                // console.log(this.selectedApprovalTemplate);
                this.isInnerShow = this.isShowApprovalTemplatePop;
                this.selectMap = new Map();
                if (!isEmpty(this.selectedApprovalTemplate.selectedApprovalTemplateIds)) {
                    this.selectedApprovalTemplateIds = this.selectedApprovalTemplate.selectedApprovalTemplateIds;
                    this.selectedApprovalTemplateNames = this.selectedApprovalTemplate.selectedApprovalTemplateNames;
                }
                // console.log("============"+this.selectedApprovalTemplateIds);
                this._getListData();
                this._getTreeData();
            },
            async _getListData () {
                await this.handleSearchInDept();
                await this.handleSearchUnInDept();
            },
            async _getTreeData () {
                let treeList = await getBusinessTreeList();
                this.treeData = treeList;
                this.isShowTree = true;
            },
            handleTreeNode (data, node, tree) {
                this.currentBusiType = data.id;
                this.currentPageInDept = 1;
                this.handleSearchInDept();
                // 初始化变量
                // this.selectedApprovalTemplateIds = '';
                // this.selectedRemovedUserIds = '';
            },
            async handleSearchInDept () {
                this.inDpetloading = true;
                let processListData = await getApprovalTemplateList({
                    pageSize: this.pageSizeInDept,
                    currentPage: this.currentPageInDept,
                    templateName: this.templateName,
                    busiType: this.currentBusiType,
                    templateState: 1 // 0:草稿 1:已发布 2:已删除
                });
                // console.log(filterProcess);
                this.templateListInBusiness = processListData.data;
                this.currentPageInDept = processListData.currentPage;
                this.pageSizeInDept = processListData.pageSize;
                this.totalPageNumInDept = processListData.totalPageNum;
                this.inDpetloading = false;
            },
            queryFormDataInDept (currentPageInDept) {
                this.currentPageInDept = currentPageInDept;
                this._getListData();
            },
            async handleSearchUnInDept () {
                // console.log(this.selectedApprovalTemplateIds);
                this.unInDpetloading = true;
                if (!isEmpty(this.selectedApprovalTemplateIds)) {
                    let ids = this.selectedApprovalTemplateIds.split(',');
                    let templateNames = this.selectedApprovalTemplateNames.split(',');
                    let selectedData = [];
                    for (var i = 0; i < ids.length; i++) {
                        selectedData.push({id: ids[i], templateName: templateNames[i]});
                    }
                    this.selectedApprovalTemplateList = selectedData;
                } else {
                    this.selectedApprovalTemplateList = [];
                }
                this.unInDpetloading = false;
            },
            queryFormDataUnInDept (currentPageUnInDept) {
                this.currentPageUnInDept = currentPageUnInDept;
                this._getListData();
            },
            async handleRemoveselectedApprovalTemplate () {
                if (!isEmpty(this.selectedRemovedUserIds)) {
                    let newIds = this.selectedRemovedUserIds.split(',');
                    let ids = this.selectedApprovalTemplateIds.split(',');
                    let templateNames = this.selectedApprovalTemplateNames.split(',');
                    let selectedData = [];
                    this.selectedApprovalTemplateIds = '';
                    this.selectedApprovalTemplateNames = '';
                    let removedMap = new Map();
                    for (var j = 0; j < newIds.length; j++) {
                        removedMap.set(newIds[j], newIds[j]);
                    }
                    for (var i = 0; i < ids.length; i++) {
                        if (!removedMap.has(ids[i])) {
                            selectedData.push({id: ids[i], templateName: templateNames[i]});
                            if (isEmpty(this.selectedApprovalTemplateIds)) {
                                this.selectedApprovalTemplateIds = ids[i];
                                this.selectedApprovalTemplateNames = templateNames[i];
                            } else {
                                this.selectedApprovalTemplateIds = this.selectedApprovalTemplateIds + ',' + ids[i];
                                this.selectedApprovalTemplateNames = this.selectedApprovalTemplateNames + ',' + templateNames[i];
                            }
                        } else {
                            this.selectMap.delete(ids[i]);
                        }
                    }
                    this.selectedApprovalTemplateList = selectedData;
                    // this.selectedApprovalTemplate.selectedApprovalTemplateIds = this.selectedApprovalTemplateIds;
                    // this.selectedApprovalTemplate.selectedApprovalTemplateNames = this.selectedApprovalTemplateNames;
                }
            },
            handleSelectionChangeInDept (rows) {
                // this.selectedApprovalTemplateIds = '';
                // this.selectedApprovalTemplateNames = '';
                if (rows) {
                    if (Array.isArray(rows)) {
                        rows.forEach(row => {
                            if (row) {
                                if (!this.selectMap.has(row.id)) {
                                    if (isEmpty(this.selectedApprovalTemplateIds)) {
                                        this.selectedApprovalTemplateIds = row.id;
                                        this.selectedApprovalTemplateNames = row.templateName;
                                    } else {
                                        this.selectedApprovalTemplateIds = this.selectedApprovalTemplateIds + ',' + row.id;
                                        this.selectedApprovalTemplateNames = this.selectedApprovalTemplateNames + ',' + row.templateName;
                                    }
                                    this.selectMap.set(row.id, row.id);
                                }
                            }
                        });
                    } else {
                        this.selectedApprovalTemplateIds = rows.id;
                        this.selectedApprovalTemplateNames = rows.templateName;
                    }
                    this.handleSearchUnInDept();
                }
            },
            handleSelectionRemovedUser (rows) {
                this.selectedRemovedUserIds = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedRemovedUserIds)) {
                                this.selectedRemovedUserIds = row.id;
                            } else {
                                this.selectedRemovedUserIds = this.selectedRemovedUserIds + ',' + row.id;
                            }
                        }
                    });
                }
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            confirmClick () {
                this.selectedApprovalTemplate.selectedApprovalTemplateIds = this.selectedApprovalTemplateIds;
                this.selectedApprovalTemplate.selectedApprovalTemplateNames = this.selectedApprovalTemplateNames;
                let arr = this.selectedApprovalTemplate.selectedApprovalTemplateIds.split(',');
                if (arr.length > this.maxItemsNum) {
                    this.messageTip('最多只能选择' + this.maxItemsNum + '条流程方案', 'warning');
                    return false;
                }
                // console.log(this.selectedApprovalTemplate);
                this.$emit('nodeClick', this.selectedApprovalTemplate);
                this.isInnerShow = false;
            }
        }
    };
</script>

<style lang="less">
    .approval-temp-select {
        height: 365px;
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ApprovalTempSelectPop/ApprovalTempSelectPop.vue